import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import Auth from '@aws-amplify/auth';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {
  }
  async canActivate() {
    const session = await Auth.currentSession().catch(console.log);
    if (session) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}